const dialogP           = require('./purchase-dialog')
const fullcontEntity    = require('../../../../../components/fullcont/fullcont-entity')
const handler           = require('./purchase-fullcont-handler')
const calculateHandler  = require('./purchase-fullcont-calculate-handler')
const textfieldHandler  = require('../../../../../components/textfield/textfield-handler')
const pdfHandler        = require('./purchase-fullcont-pdf-handler')
const snack             = require('../../../../../components/snack/snack')
const purchaseFullcont  = require('./purchase-fullcont')


// precaucion selling price menor, boton update / update print
async function updateCaution(detail, htmlFc) {
    let min_amount        = htmlFc.fullcontHTML.querySelector("#purchase_form_min_amount").querySelector(".elem").value;
    let price             = htmlFc.fullcontHTML.querySelector("#purchase_form_price").querySelector(".elem").value;
    let differenceFound   = false; // Variable para rastrear si se encontró alguna diferencia
    let invest_amount_sum = "";
    let invest_amount     = "";
    let error             = false;

    if (!await handler.verifyItemQtyUsed(htmlFc)) {
        return false;
    }


    if (!await handler.validatedPuchasePayment(htmlFc)) {
        return false;
    }

    // para validar que en el mt de los lost no se tenga algun campo vacio como el item, qty y price
    let allLost = htmlFc.fullcontHTML.querySelectorAll("#purchase_form_purchase_vs_lost  .line");
    for (let i = 0; i < allLost.length; i++) {

        let item          = allLost[i].querySelector(".purchase_vs_itemId");
        let item_selected = item.getAttribute("selected");
        let line          = allLost[i];

        if (JSON.parse(item_selected).length == 0) {
            textfieldHandler.error(item);
            snack.start({ act: 'show', id: 'inputErrors', });
            error = true;
            break;
        }

        let input_qty       = line.querySelector(".lost_qty input");
        let input_qty_value = (input_qty.value == "" || parseFloat(input_qty.value) == NaN || parseFloat(input_qty.value) == 0) ? 0 : parseFloat(input_qty.value);
        if (input_qty_value == 0) {
            textfieldHandler.error(input_qty.closest(".textfield"));
            snack.start({ act: 'show', id: 'invalidValue', });
            error = true;
            break;

        }

        let input_price       = line.querySelector(".lost_price input");
        let input_price_value = (input_price.value == "" || parseFloat(input_price.value) == NaN || parseFloat(input_price.value) == 0) ? 0 :
            parseFloat(input_price.value);
        if (input_price_value == 0) {
            textfieldHandler.error(input_qty.closest(".textfield"));
            snack.start({ act: 'show', id: 'invalidValue', });
            error = true;
            break;
        }
    }

    // si encuentra algun error, debe mostrar el mt de lost
    if (error) {
        handler.EventClickShowHideMt(true);
        return true
    }

    //Para validar las cantidades de los item en el MT de Lost
    //----------------START
    let lines = htmlFc.fullcontHTML.querySelectorAll('#purchase_form_purchase_vs_lost .line');
    //para guardar los item que se verificaron
    let item_checked = new Set();
    for (let index = 0; index < lines.length; index++) {
        let line          = lines[index];
        let ac_item       = line.querySelector(".purchase_vs_itemId")
        let item_selected = ac_item.getAttribute("selected");

        try {
            item_selected = JSON.parse(ac_item.getAttribute("selected"));
        } catch (e) {
            console.error("Error parsing JSON: selected");
            return false;
        }

        if (item_selected.length > 0) {
            let purchase_vs_itemId = item_selected[0];
            if (!item_checked.has(purchase_vs_itemId)) {
                let qty_available = calculateHandler.getQtyAvailable(purchase_vs_itemId);

                if (!calculateHandler.verifyQtyItem(purchase_vs_itemId, qty_available, htmlFc)) {
                    return false;
                }
                item_checked.add(purchase_vs_itemId);
            }
        }

    }
    //----------------END

    if (!calculateHandler.verifySpentCredit(htmlFc)) {
        return false;
    }

    if (htmlFc.entityMT[0].html.children.length > 0) {

        let verifyItemCostPrice = purcahseVsItem(htmlFc);
        // se coloco el flag detail.save == undefined ya que cuando se dispara el dialog y se oprime guardar la propiedad 
        // detail.save no sera undefined, sin esta validacion el dialog se volvia a llamar
        if (verifyItemCostPrice === true && detail.save == undefined) {
            if (detail.type == 'pdf') {
                dialogP.start({ act: "show", dest: 'purchase', id: "purchaseSellingPricePrint", entity: 'purchase' })
            } else {
                dialogP.start({ act: "show", dest: 'purchase', id: "purchaseSellingPrice", entity: 'purchase' })
            }
        } else {
            if (verifyItemCostPrice == true) {
                // para que se pase el boton update en vez del boton update del dialogo
                // ya que esto da error al momento de quitar el icono de error de los tab
                detail.ev =  {target: htmlFc.fullcontHTML.querySelector('#update_button')};
            }
            console.log('create hay mt desde las iteraciones')
            if (detail.type == 'pdf') {
                fullcontEntity.update(detail, htmlFc, handler.processAfterUpdate)
                setTimeout(() => {
                    pdfHandler.purchasePrintPdf(detail, htmlFc)
                }, 2000)
            } else {

                fullcontEntity.update(detail, htmlFc, handler.processAfterUpdate)
            }
        }

    } else if (htmlFc.entityMT[1].data.length != 0) {

        for (const elem of htmlFc.entityMT) {
            if (elem.tableName === "purchase_vs_investment") {
                for (const data of elem.data) {
                    invest_amount_sum += parseFloat(data.invested_amount);
                    invest_amount     = data.invested_amount;

                    if (price >= invest_amount_sum && min_amount < invest_amount) {
                        differenceFound = true;
                        break;  // Salir del bucle interior
                    }
                }
                if (differenceFound) {
                    break;  // Salir del bucle exterior si se encontró una iteración que no cumple con la condición
                }
            }
        }

        if (differenceFound) {
            // Se encontró una iteración que no cumple con la condición
            return false;
        } else {
            // Todas las iteraciones cumplen con la condición
            if (purcahseVsItem(htmlFc) === true) {
                if (detail.type == 'pdf') {
                    dialogP.start({ act: "show", dest: 'purchase', id: "purchaseSellingPricePrint", entity: 'purchase' })
                } else {
                    dialogP.start({ act: "show", dest: 'purchase', id: "purchaseSellingPrice", entity: 'purchase' })
                }

            } else {
                fullcontEntity.update(detail, htmlFc, handler.processAfterUpdate)
            }
        }

    } else {
        //console.log('create no hay mt')
        fullcontEntity.update(detail, htmlFc, handler.processAfterUpdate)
    }
}

// precaucion selling price menor, boton save
function creationCaution(detail, htmlFc) {
    let min_amount        = htmlFc.fullcontHTML.querySelector("#purchase_form_min_amount").querySelector(".elem").value;
    let price             = htmlFc.fullcontHTML.querySelector("#purchase_form_price").querySelector(".elem").value;
    let differenceFound   = false; // Variable para rastrear si se encontró alguna diferencia
    let invest_amount_sum = "";
    let invest_amount     = "";

    if (htmlFc.entityMT[0].html.children.length > 0) {

        if (purcahseVsItem(htmlFc) === true) {
            dialogP.start({ act: "show", dest: 'purchase', id: "purchaseCreateSellingPrice", entity: 'purchase' })
        } 

    } else if (htmlFc.entityMT[1].data.length != 0) {

        for (const elem of htmlFc.entityMT) {
            if (elem.tableName === "purchase_vs_investment") {
                for (const data of elem.data) {
                    invest_amount_sum += parseFloat(data.invested_amount);
                    invest_amount     = data.invested_amount;

                    if (price >= invest_amount_sum && min_amount < invest_amount) {
                        differenceFound = true;
                        break;  // Salir del bucle interior
                    }
                }
                if (differenceFound) {
                    break;  // Salir del bucle exterior si se encontró una iteración que no cumple con la condición
                }
            }
        }

        if (differenceFound) {
            // Se encontró una iteración que no cumple con la condición
            return false;
        } else {
            // Todas las iteraciones cumplen con la condición
            if (purcahseVsItem(htmlFc) === true) {
                dialogP.start({ act: "show", dest: 'purchase', id: "purchaseCreateSellingPrice", entity: 'purchase' })

            } else {
                fullcontEntity.addOne(detail, htmlFc)
            }
        }

    } else {
        fullcontEntity.addOne(detail, htmlFc)
    }
}

// verifica el selling price y el unit price de cada elemento de la mt purchase vs item
function purcahseVsItem(htmlFc) {
    let diferenciaEncontrada = false; // Inicializamos la bandera
    for (const elem of htmlFc.entityMT) {
        if (elem.tableName === "purchase_vs_item") {
            elem.html.querySelectorAll('.selling_price').forEach((sellingInput, index) => {
                const selling_value = parseFloat(sellingInput.querySelector('input[type="number"]').value);
                const unit_value    = parseFloat(elem.html.querySelectorAll('.unit_price')[index].querySelector('input[type="number"]').value);

                if (unit_value >= selling_value) {
                    diferenciaEncontrada = true; // Si se encuentra una diferencia, establecemos la bandera en true
                }
            });

            if (diferenciaEncontrada) {
                return true;
            } else {
                return false;
            }
        }
    }
}

export function beforeupdate(detail, htmlFc) {
    if (!htmlFc.fullcontHTML.classList.contains('mode-add')) {
        updateCaution(detail, htmlFc);
    } else {
        fullcontEntity.saveFromDialog(detail, htmlFc, purchaseFullcont.processAfterAdd);
    }
}